"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/fourFive/fourFiveViewModel',["require", "exports", "knockout", "jquery", "viewModels/fourFive/fourFiveUserViewModel", "viewModels/fourFive/fourFivePolicyViewModel", "viewModels/fourFive/fourFiveTestViewModel", "viewModels/fourFive/fourFiveAppDetailViewModel", "viewModels/fourFive/fourFiveUserActivityViewModel", "viewModels/fourFive/fourFiveUserCommunicationViewModel", "viewModels/fourFive/fourFiveUserCallbackViewModel", "viewModels/fourFive/fourFiveUserAggDataViewModel", "viewModels/fourFive/fourFiveScoreViewModel", "services/fourFiveService"], function (require, exports, ko, jquery, FourFiveUserViewModel, FourFivePolicyViewModel, FourFiveTestViewModel, FourFiveAppDetailViewModel, FourFiveUserActivityViewModel, FourFiveUserCommunicationViewModel, FourFiveUserCallbackViewModel, FourFiveUserAggDataViewModel, FourFiveScoreViewModel, fourFiveService) {
    "use strict";

    var FourFiveViewModel = function () {
        function FourFiveViewModel() {
            _classCallCheck(this, FourFiveViewModel);

            this.tileIndex = 200;
            this.fourFiveUser = ko.observable(null);
            this.fourFivePolicy = ko.observable(null);
            this.fourFiveTests = ko.observableArray([]);
            this.fourFiveAppDetails = ko.observableArray([]);
            this.fourFiveUserActivities = ko.observableArray([]);
            this.fourFiveUserCommunications = ko.observableArray([]);
            this.fourFiveDataDrop = ko.observable(null);
            this.fourFiveUserCallbacks = ko.observableArray([]);
            this.fourFiveSuspendedScoring = ko.observable(false);
            this.fourFiveScoreOptInDates = ko.observableArray([]);
            this.fourFiveLeaderboardScores = ko.observableArray([]);
            this.fourFiveNonLeaderboardScores = ko.observableArray([]);
            this.fourFiveUserAggData = ko.observable(null);
            this.fourFiveUserLoading = ko.observable(false);
            this.fourFiveUserLoaded = ko.observable(false);
            this.fourFivePolicyLoading = ko.observable(false);
            this.fourFivePolicyLoaded = ko.observable(false);
            this.fourFiveTestsLoading = ko.observable(false);
            this.fourFiveTestsLoaded = ko.observable(false);
            this.fourFiveAppDetailsLoading = ko.observable(false);
            this.fourFiveAppDetailsLoaded = ko.observable(false);
            this.fourFiveUserActivitiesLoading = ko.observable(false);
            this.fourFiveUserActivitiesLoaded = ko.observable(false);
            this.fourFiveUserCommunicationsLoading = ko.observable(false);
            this.fourFiveUserCommunicationsLoaded = ko.observable(false);
            this.fourFiveUserScoreLoading = ko.observable(false);
            this.fourFiveUserScoreLoaded = ko.observable(false);
            this.fourFiveDataDropLoading = ko.observable(false);
            this.fourFiveDataDropLoaded = ko.observable(false);
            this.fourFiveCallbacksLoading = ko.observable(false);
            this.fourFiveCallbacksLoaded = ko.observable(false);
            this.fourFiveUserAggDataLoading = ko.observable(false);
            this.fourFiveUserAggDataLoaded = ko.observable(false);
            this.loaded = ko.observable(false);
        }

        _createClass(FourFiveViewModel, [{
            key: "loadUser",
            value: function loadUser(userId) {
                var _this = this;

                this.clear();
                var deferreds = [];
                this.fourFiveUserLoading(true);
                var userDeferred = fourFiveService.user(userId).then(function (user) {
                    _this.fourFiveUser(new FourFiveUserViewModel(user));
                    _this.fourFiveUserLoading(false);
                    _this.fourFiveUserLoaded(true);
                });
                deferreds.push(userDeferred);
                this.fourFivePolicyLoading(true);
                var policyDeferred = fourFiveService.policy(userId).then(function (policy) {
                    if (policy) {
                        _this.fourFivePolicy(new FourFivePolicyViewModel(policy));
                    }
                    _this.fourFivePolicyLoading(false);
                    _this.fourFivePolicyLoaded(true);
                });
                deferreds.push(policyDeferred);
                this.fourFiveTestsLoading(true);
                var testsDeferred = fourFiveService.tests(userId).then(function (userTests) {
                    userTests.tests.forEach(function (test) {
                        var testViewModel = new FourFiveTestViewModel(test);
                        _this.fourFiveTests.push(testViewModel);
                    });
                    _this.fourFiveTestsLoading(false);
                    _this.fourFiveTestsLoaded(true);
                });
                deferreds.push(testsDeferred);
                this.fourFiveAppDetailsLoading(true);
                var appDetailsDeferred = fourFiveService.appDetails(userId).then(function (userAppDetails) {
                    userAppDetails.appDetails.forEach(function (appDetail) {
                        var appDetailViewModel = new FourFiveAppDetailViewModel(appDetail);
                        _this.fourFiveAppDetails.push(appDetailViewModel);
                    });
                    _this.fourFiveAppDetailsLoading(false);
                    _this.fourFiveAppDetailsLoaded(true);
                });
                deferreds.push(appDetailsDeferred);
                this.fourFiveUserActivitiesLoading(true);
                var activitiesDeferred = fourFiveService.activities(userId).then(function (userActivities) {
                    userActivities.activities.forEach(function (activity) {
                        var userActivityViewModel = new FourFiveUserActivityViewModel(activity);
                        _this.fourFiveUserActivities.push(userActivityViewModel);
                    });
                    _this.fourFiveUserActivitiesLoading(false);
                    _this.fourFiveUserActivitiesLoaded(true);
                });
                deferreds.push(activitiesDeferred);
                this.fourFiveUserCommunicationsLoading(true);
                var communicationsDeferred = fourFiveService.communications(userId).then(function (userCommunications) {
                    userCommunications.communications.forEach(function (communication) {
                        var userCommunicationViewModel = new FourFiveUserCommunicationViewModel(communication);
                        _this.fourFiveUserCommunications.push(userCommunicationViewModel);
                    });
                    _this.fourFiveUserCommunicationsLoading(false);
                    _this.fourFiveUserCommunicationsLoaded(true);
                });
                deferreds.push(communicationsDeferred);
                this.fourFiveUserScoreLoading(true);
                var scoreDeferred = this.getUserScores(userId, 'This Month');
                deferreds.push(scoreDeferred);
                this.fourFiveDataDropLoading(true);
                var dataDropDeferred = fourFiveService.dataDrop(userId).then(function (dataDrop) {
                    if (dataDrop) {
                        _this.fourFiveDataDrop(JSON.parse(dataDrop));
                    }
                    _this.fourFiveDataDropLoading(false);
                    _this.fourFiveDataDropLoaded(true);
                });
                deferreds.push(dataDropDeferred);
                this.fourFiveCallbacksLoading(true);
                var callbacksDeferred = fourFiveService.callbacks(userId).then(function (userCallbacks) {
                    userCallbacks.callbacks.forEach(function (callback) {
                        var userCallbackViewModel = new FourFiveUserCallbackViewModel(callback);
                        _this.fourFiveUserCallbacks.push(userCallbackViewModel);
                    });
                    _this.fourFiveCallbacksLoading(false);
                    _this.fourFiveCallbacksLoaded(true);
                });
                deferreds.push(callbacksDeferred);
                this.fourFiveUserAggDataLoading(true);
                var userAggDataDeferred = fourFiveService.userAggData(userId).then(function (aggData) {
                    _this.fourFiveUserAggData(new FourFiveUserAggDataViewModel(aggData));
                    _this.fourFiveUserAggDataLoading(false);
                    _this.fourFiveUserAggDataLoaded(true);
                });
                deferreds.push(userAggDataDeferred);
                $.when.apply($, deferreds).done(function () {
                    _this.loaded(true);
                });
            }
        }, {
            key: "updateUserType",
            value: function updateUserType() {
                var _this2 = this;

                var deferred = jquery.Deferred();
                this.fourFiveUserLoading(true);
                fourFiveService.updateUserType(this.fourFiveUser().userId(), this.fourFiveUser().typeId()).then(function () {
                    fourFiveService.user(_this2.fourFiveUser().userId()).then(function (user) {
                        _this2.fourFiveUser(new FourFiveUserViewModel(user));
                        _this2.fourFiveUserLoading(false);
                        _this2.fourFiveUserLoaded(true);
                        deferred.resolve();
                    });
                });
                return deferred.promise();
            }
        }, {
            key: "getUserScores",
            value: function getUserScores(userId, timeFrame) {
                var _this3 = this;

                return fourFiveService.score(userId, timeFrame).then(function (userScore) {
                    var leaderboardScores = [];
                    userScore.leaderboardScores.forEach(function (score) {
                        var leaderboardScore = new FourFiveScoreViewModel(score);
                        leaderboardScores.push(leaderboardScore);
                    });
                    var nonLeaderboardScores = [];
                    userScore.nonLeaderboardScores.forEach(function (score) {
                        var nonLeaderboardScore = new FourFiveScoreViewModel(score);
                        nonLeaderboardScores.push(nonLeaderboardScore);
                    });
                    _this3.fourFiveLeaderboardScores(leaderboardScores);
                    _this3.fourFiveNonLeaderboardScores(nonLeaderboardScores);
                    _this3.fourFiveScoreOptInDates(userScore.scoreOptInDates);
                    _this3.fourFiveSuspendedScoring(userScore.suspendedScoring);
                    _this3.fourFiveUserScoreLoading(false);
                    _this3.fourFiveUserScoreLoaded(true);
                });
            }
        }, {
            key: "getNewIndex",
            value: function getNewIndex(tileId) {
                this.tileIndex++;
                return { id: tileId, index: this.tileIndex };
            }
        }, {
            key: "clear",
            value: function clear() {
                this.fourFiveUser(null);
                this.fourFivePolicy(null);
                this.fourFiveTests([]);
                this.fourFiveAppDetails([]);
                this.fourFiveUserActivities([]);
                this.fourFiveUserCommunications([]);
                this.fourFiveDataDrop(null);
                this.fourFiveUserCallbacks([]);
                this.fourFiveUserLoading(false);
                this.fourFiveUserLoaded(false);
                this.fourFivePolicyLoading(false);
                this.fourFivePolicyLoaded(false);
                this.fourFiveTestsLoading(false);
                this.fourFiveTestsLoaded(false);
                this.fourFiveAppDetailsLoading(false);
                this.fourFiveAppDetailsLoaded(false);
                this.fourFiveUserActivitiesLoading(false);
                this.fourFiveUserActivitiesLoaded(false);
                this.fourFiveUserCommunicationsLoading(false);
                this.fourFiveUserCommunicationsLoaded(false);
                this.fourFiveDataDropLoading(false);
                this.fourFiveDataDropLoaded(false);
                this.fourFiveCallbacksLoading(false);
                this.fourFiveCallbacksLoaded(false);
                this.fourFiveUserAggDataLoading(false);
                this.fourFiveUserAggDataLoaded(false);
                this.loaded(false);
            }
        }]);

        return FourFiveViewModel;
    }();

    return new FourFiveViewModel();
});
//# sourceMappingURL=fourFiveViewModel.js.map;
